import { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GlobalStyle from './GlobalStyle';
import Home from './components/Home';
import AuthenticationContext from './shared/contexts/AuthenticationContext';
import Loading from './shared/components/common/Loading';
import Authorize from './shared/authentication/components/Authorize';
import Login from './shared/authentication/components/Login';
import { getConfig, loadConfig } from './config/envconfig.ts';
import { initElasticApm } from './elasticApm.ts';
import { Toastr } from './components/Toastr.styles.ts';
import { BackendApiContextProvider } from './shared/contexts/BackendApiContext.tsx';
import TranslationContextProvider from './shared/contexts/TranslationContext.tsx';
import { RedirectToWebsite } from './components/RedirectToWebsite.tsx';
const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const checkConfig = async () => {
            try {
                getConfig();
            } catch {
                await loadConfig();
                const config = getConfig();
                initElasticApm(config);
            } finally {
                setIsLoading(false);
            }
        };

        checkConfig();
    }, []);
    const url = new URL(window.location.href);
    const marketFromParams = url.searchParams.get('market');
    const market = marketFromParams || 'global';
    const emptySearchParams = url.searchParams.size === 0;

    return isLoading ? (
        <Loading />
    ) : (
        <>
            <GlobalStyle />
            <Toastr />
            <AuthenticationContext>
                <BackendApiContextProvider>
                    <TranslationContextProvider market={market}>
                        <Suspense fallback={<Loading />}>
                            <BrowserRouter basename="/light">
                                <Routes>
                                    <Route
                                        path="/loading"
                                        element={<Loading />}
                                    />
                                    <Route
                                        path="/authorized"
                                        element={<Authorize />}
                                    />
                                    <Route
                                        path="*"
                                        element={
                                            emptySearchParams ? (
                                                <RedirectToWebsite />
                                            ) : (
                                                <Home market={market} />
                                            )
                                        }
                                    />
                                    <Route path="/login" element={<Login />} />
                                </Routes>
                            </BrowserRouter>
                        </Suspense>
                    </TranslationContextProvider>
                </BackendApiContextProvider>
            </AuthenticationContext>
        </>
    );
};

export default App;
